import { render, staticRenderFns } from "./MarketplaceGeneralSearchProvider.vue?vue&type=template&id=8b994854"
import script from "./MarketplaceGeneralSearchProvider.vue?vue&type=script&lang=js"
export * from "./MarketplaceGeneralSearchProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports